<ion-grid>
  @if (internalItems.length === 0) {
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-item class="no-items" lines="none">
          <ion-icon slot="start" name="alert-circle-outline"></ion-icon>
          <ion-text>No items yet</ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
  }
  <ion-row>
    <ion-col size="12" class="ion-no-padding">
      <ion-list class="item-list">
        @for (item of internalItems; track item) {
          <rc-item-in-list
            [selectableItem]="item"
            [mode]="mode"
            [showScanButtonIfNeeded]="showScanButton"
            [showStatus]="showStatus"
            [withItemStatus]="withItemStatus"
            (onSelect)="onClickSelect($event)"
          (onDeselect)="onClickDeselect($event)"></rc-item-in-list>
        }
      </ion-list>
    </ion-col>
  </ion-row>
</ion-grid>
